import { Component, Injector, ChangeDetectionStrategy } from "@angular/core";
import { AbstractComponent } from "lib-trend-core";

@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillingComponent extends AbstractComponent {

  constructor(injector: Injector) {
    super(injector);
  }

}